export const buildBounds = (properties: any[]) => {
  const bounds = new google.maps.LatLngBounds()

  for (const property of properties) {
    if (property.location) {
      bounds.extend(new google.maps.LatLng(property.location.coordinates[1], property.location.coordinates[0]))
    }
  }

  return bounds
}

export const getPixelPositionOffset = (width: number, height: number) => ({
  x: -(width / 2),
  y: -(height + 4),
})
